import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossButtonIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#EFF1F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4851 7.51465L7.51454 24.4852",
			stroke: "#2B313A",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4851 24.4851L7.51455 7.51455",
			stroke: "#2B313A",
			strokeWidth: 1.5
		})
	]
});
export default SvgCrossButtonIcon;
